/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactSummary } from './ContactSummary.js';
import {
    ContactSummaryFromJSON,
    ContactSummaryFromJSONTyped,
    ContactSummaryToJSON,
} from './ContactSummary.js';
import type { CustomerEntry } from './CustomerEntry.js';
import {
    CustomerEntryFromJSON,
    CustomerEntryFromJSONTyped,
    CustomerEntryToJSON,
} from './CustomerEntry.js';
import type { CustomerNote } from './CustomerNote.js';
import {
    CustomerNoteFromJSON,
    CustomerNoteFromJSONTyped,
    CustomerNoteToJSON,
} from './CustomerNote.js';
import type { CustomerPreview } from './CustomerPreview.js';
import {
    CustomerPreviewFromJSON,
    CustomerPreviewFromJSONTyped,
    CustomerPreviewToJSON,
} from './CustomerPreview.js';

/**
 * 
 * @export
 * @interface CustomerDetails
 */
export interface CustomerDetails {
    /**
     * 
     * @type {CustomerPreview}
     * @memberof CustomerDetails
     */
    preview?: CustomerPreview;
    /**
     * 
     * @type {Array<CustomerEntry>}
     * @memberof CustomerDetails
     */
    entries?: Array<CustomerEntry>;
    /**
     * 
     * @type {Array<ContactSummary>}
     * @memberof CustomerDetails
     */
    contactsHistory?: Array<ContactSummary>;
    /**
     * 
     * @type {Array<CustomerNote>}
     * @memberof CustomerDetails
     */
    customerNotes?: Array<CustomerNote>;
}

/**
 * Check if a given object implements the CustomerDetails interface.
 */
export function instanceOfCustomerDetails(value: object): boolean {
    return true;
}

export function CustomerDetailsFromJSON(json: any): CustomerDetails {
    return CustomerDetailsFromJSONTyped(json, false);
}

export function CustomerDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'preview': json['preview'] == null ? undefined : CustomerPreviewFromJSON(json['preview']),
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(CustomerEntryFromJSON)),
        'contactsHistory': json['contactsHistory'] == null ? undefined : ((json['contactsHistory'] as Array<any>).map(ContactSummaryFromJSON)),
        'customerNotes': json['customerNotes'] == null ? undefined : ((json['customerNotes'] as Array<any>).map(CustomerNoteFromJSON)),
    };
}

export function CustomerDetailsToJSON(value?: CustomerDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'preview': CustomerPreviewToJSON(value['preview']),
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(CustomerEntryToJSON)),
        'contactsHistory': value['contactsHistory'] == null ? undefined : ((value['contactsHistory'] as Array<any>).map(ContactSummaryToJSON)),
        'customerNotes': value['customerNotes'] == null ? undefined : ((value['customerNotes'] as Array<any>).map(CustomerNoteToJSON)),
    };
}

